// extracted by mini-css-extract-plugin
export default {"header":"BriefsHub_header__2YzWX","tile":"BriefsHub_tile__EOzRM","title":"BriefsHub_title__Coz4x","description":"BriefsHub_description__H4Ysp"};